import { defineComponent as _defineComponent } from 'vue'
import { tenantsService } from '@/services/tenants.service';
import TableActionButton2 from '@/components/tableWithActions/TableActionButton2.vue';
import TableWithActions2 from '@/components/tableWithActions/TableWithActions2.vue';
import CustomerFilters from './CustomerFilters.vue';
import {
  containsSubscribers,
  hasSubscriptions,
  isCurrentUserSubscribed,
} from './commons/matchers';
import {
  CustomerEServiceData,
  CustomerFilterValues,
  SubscribedUser,
} from './commons/model';
import {
  createTextListMatcher,
  FilterMatcher,
  matchIgnoringCase,
} from '@/utils/table';
import { onBeforeMount, ref } from 'vue';
import { useEServiceCenterRouter } from '@/library-services/e-service-center-router';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EServiceCenterCustomers',
  setup(__props) {

const customers = ref<CustomerEServiceData[]>([]);
const isLoading = ref(false);

const MAX_SUBSCRIBED_USERS_SHOWN = 5;

const filterMatchers: Record<keyof CustomerFilterValues, FilterMatcher> = {
  mySubscriptions: isCurrentUserSubscribed,
  noSubscriptions: hasSubscriptions,
  name: createTextListMatcher<CustomerFilterValues>('name'),
  subsidiaryName: createTextListMatcher<CustomerFilterValues>('subsidiaryName'),
  subscribers: containsSubscribers,
};

const router = useEServiceCenterRouter();
const { t } = useI18n();

onBeforeMount(() => {
  fetchCustomers();
});

async function fetchCustomers() {
  try {
    customers.value = await tenantsService.getEServiceCenterData();
  } finally {
    isLoading.value = false;
  }
}

function formatUserNames(userNames: SubscribedUser[]): string {
  return userNames
    .map((user) => user.name)
    .slice(0, MAX_SUBSCRIBED_USERS_SHOWN)
    .join(', ');
}

async function goToCustomerDevices(customer: CustomerEServiceData) {
  await router.goToCustomerEquipment(customer.idDh);
}

async function goToFirstEquipmentCareConsole(customer: CustomerEServiceData) {
  await router.goToEquipmentCareConsole(
    customer.idDh,
    customer.equipmentIds[0],
  );
}

async function goToFirstEquipmentWorkCenterConsole(
  customer: CustomerEServiceData,
) {
  await router.goToEquipmentWorkCenterConsole(
    customer.idDh,
    customer.equipmentIds[0],
  );
}

function subscribedUsersMatcher(
  customer: CustomerEServiceData,
  searchText: string,
): boolean {
  return matchIgnoringCase(
    customer.subscribedUsers.map((x) => x.name).join(''),
    searchText,
  );
}

return { __sfc: true,customers, isLoading, MAX_SUBSCRIBED_USERS_SHOWN, filterMatchers, router, t, fetchCustomers, formatUserNames, goToCustomerDevices, goToFirstEquipmentCareConsole, goToFirstEquipmentWorkCenterConsole, subscribedUsersMatcher, TableActionButton2, TableWithActions2, CustomerFilters }
}

})